import { render, staticRenderFns } from "./need-modify-pwd.vue?vue&type=template&id=b9c4bcee&scoped=true&"
import script from "./need-modify-pwd.vue?vue&type=script&lang=js&"
export * from "./need-modify-pwd.vue?vue&type=script&lang=js&"
import style0 from "./need-modify-pwd.vue?vue&type=style&index=0&id=b9c4bcee&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c4bcee",
  null
  
)

export default component.exports